"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6630],{

/***/ 90868:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(55904);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.f8 = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 55904:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'circle-check';
var width = 512;
var height = 512;
var aliases = [61533,"check-circle"];
var unicode = 'f058';
var svgPathData = 'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 52699:
/***/ (function(__unused_webpack_module, exports) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'clock';
var width = 512;
var height = 512;
var aliases = [128339,"clock-four"];
var unicode = 'f017';
var svgPathData = 'M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.SZ = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 24372:
/***/ (function(__unused_webpack_module, exports) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'envelope';
var width = 512;
var height = 512;
var aliases = [128386,9993,61443];
var unicode = 'f0e0';
var svgPathData = 'M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.FU = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 27898:
/***/ (function(__unused_webpack_module, exports) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'grid-2';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e196';
var svgPathData = 'M224 80c0-26.5-21.5-48-48-48H80C53.5 32 32 53.5 32 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80zm0 256c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336zM288 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48zM480 336c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.em = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 12454:
/***/ (function(__unused_webpack_module, exports) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'id-card';
var width = 576;
var height = 512;
var aliases = [62147,"drivers-license"];
var unicode = 'f2c2';
var svgPathData = 'M0 96l576 0c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm0 32V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128H0zM64 405.3c0-29.5 23.9-53.3 53.3-53.3H234.7c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7H74.7c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Uk = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 37553:
/***/ (function(__unused_webpack_module, exports) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'link';
var width = 640;
var height = 512;
var aliases = [128279,"chain"];
var unicode = 'f0c1';
var svgPathData = 'M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.nN = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 37050:
/***/ (function(__unused_webpack_module, exports) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'location-dot';
var width = 384;
var height = 512;
var aliases = ["map-marker-alt"];
var unicode = 'f3c5';
var svgPathData = 'M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.op = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 29397:
/***/ (function(__unused_webpack_module, exports) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'map-location-dot';
var width = 576;
var height = 512;
var aliases = ["map-marked-alt"];
var unicode = 'f5a0';
var svgPathData = 'M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152V422.8c0 9.8-6 18.6-15.1 22.3L416 503V200.4zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6V451.8L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77V504.3L192 449.4V255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Yi = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 55083:
/***/ (function(__unused_webpack_module, exports) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'phone-volume';
var width = 512;
var height = 512;
var aliases = ["volume-control-phone"];
var unicode = 'f2a0';
var svgPathData = 'M280 0C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Eo = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 5503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ImageWithFallback; }
/* harmony export */ });
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);



function ImageWithFallback(_ref) {
  var src = _ref.src,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? "" : _ref$alt,
      className = _ref.className,
      _ref$fallback = _ref.fallback;
  _ref$fallback = _ref$fallback === void 0 ? {} : _ref$fallback;
  var _ref$fallback$size = _ref$fallback.size,
      size = _ref$fallback$size === void 0 ? "640x16:9" : _ref$fallback$size,
      _ref$fallback$bg = _ref$fallback.bg,
      bg = _ref$fallback$bg === void 0 ? "eeeeee" : _ref$fallback$bg,
      _ref$fallback$color = _ref$fallback.color,
      color = _ref$fallback$color === void 0 ? "333333" : _ref$fallback$color,
      _ref$fallback$text = _ref$fallback.text,
      text = _ref$fallback$text === void 0 ? alt || "DaMaMaps" : _ref$fallback$text,
      fallbackSrc = _ref$fallback.src;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(!src),
      error = _useState[0],
      setError = _useState[1];

  fallbackSrc = fallbackSrc || "https://dummyimage.com/".concat(size, "/").concat(bg, "/").concat(color, "&text=").concat(encodeURIComponent(text));
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
    src: error ? fallbackSrc : src,
    layout: 'fill',
    alt: alt,
    className: className,
    onError: function onError() {
      return setError(true);
    }
  });
}

/***/ }),

/***/ 4656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Rating; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faStar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84887);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faStar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62361);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67814);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44612);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57851);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);




var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function Rating(_ref) {
  var className = _ref.className,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread({
    icon: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
      icon: _fortawesome_pro_solid_svg_icons_faStar__WEBPACK_IMPORTED_MODULE_5__/* .faStar */ .T
    }),
    emptyIcon: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
      icon: _fortawesome_pro_regular_svg_icons_faStar__WEBPACK_IMPORTED_MODULE_6__/* .faStar */ .T
    }),
    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_7__/* .twMerge */ .m)('text-primary text-sm shrink-0', className)
  }, props));
}

/***/ }),

/***/ 12424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LocationLayout; }
});

// EXTERNAL MODULE: ./layouts/Default.js + 5 modules
var Default = __webpack_require__(87607);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faMapLocationDot.js
var faMapLocationDot = __webpack_require__(29397);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faPhoneVolume.js
var faPhoneVolume = __webpack_require__(55083);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCheckCircle.js
var faCheckCircle = __webpack_require__(90868);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faGrid2.js
var faGrid2 = __webpack_require__(27898);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faClock.js
var faClock = __webpack_require__(52699);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faIdCard.js
var faIdCard = __webpack_require__(12454);
// EXTERNAL MODULE: ./components/blocks/Wrapper.js
var Wrapper = __webpack_require__(80819);
// EXTERNAL MODULE: ./components/blocks/Container.js
var Container = __webpack_require__(75046);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
// EXTERNAL MODULE: ./components/ImageWithFallback.js
var ImageWithFallback = __webpack_require__(5503);
// EXTERNAL MODULE: ./components/Rating.js
var Rating = __webpack_require__(4656);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./lib/utils/calcOpenNow.js
var calcOpenNow = __webpack_require__(95271);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 32 modules
var esm = __webpack_require__(57731);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(3580);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./components/storesPage/LocationHeader.js




















function LocationHeader() {
  var location = (0,es/* useSelector */.v9)(function (state) {
    return state.location.location;
  });

  var _useState = (0,react.useState)(false),
      openNow = _useState[0],
      setOpenNow = _useState[1];

  var _useState2 = (0,react.useState)(''),
      closeTime = _useState2[0],
      setCloseTime = _useState2[1];

  var _useState3 = (0,react.useState)({
    located: false,
    latitude: 0,
    longitude: 0
  }),
      geo = _useState3[0],
      setGeo = _useState3[1];

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  (0,react.useEffect)(function () {
    console.log('location: ', location);

    var _calcOpenNow = (0,calcOpenNow/* default */.Z)(location.business_hours, location.timezone),
        isOpen = _calcOpenNow.isOpen,
        closeTime = _calcOpenNow.closeTime;

    setOpenNow(isOpen);
    setCloseTime(closeTime);
    (0,helper.locate)(setGeo);
    setLoaded(true);
  }, []);

  var _useState4 = (0,react.useState)(false),
      isMobile = _useState4[0],
      setIsMobile = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      loaded = _useState5[0],
      setLoaded = _useState5[1];

  (0,react.useEffect)(function () {
    if (loaded) {
      setIsMobile((0,helper.checkMobile)());
    }
  }, [loaded]);
  (0,react.useEffect)(function () {
    console.log('here: ', (0,helper.checkMobile)(), isMobile);
  }, [isMobile]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper/* default */.Z, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
      className: isMobile ? "flex flex-col" : "flex",
      children: loaded ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [isMobile ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          className: "items-center self-center relative w-32 mr-8 after:block after:content-[''] after:pb-[100%] after:w-full",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWithFallback/* default */.Z, {
            src: location.avatar_url,
            alt: location.name,
            className: 'object-contain',
            fallback: {
              size: '640x1:1'
            }
          })
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          className: "relative w-48 mr-8 after:block after:content-[''] after:pb-[100%] after:w-full",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWithFallback/* default */.Z, {
            src: location.avatar_url,
            alt: location.name,
            className: 'object-contain',
            fallback: {
              size: '640x1:1'
            }
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          className: isMobile ? "w-fit" : "grow shrink",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
            className: "text-2xl font-bold mb-2",
            children: location.name
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "flex flex-nowrap items-center mb-4",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "text-xs mr-2",
              children: location.rating.toFixed(1)
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Rating/* default */.Z, {
              value: location.rating || 5,
              precision: 0.5,
              readOnly: true,
              className: 'mr-2'
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              className: "text-xs",
              children: ["(", location.reviews_count, ")"]
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: isMobile ? "w-fit grid gap-2 grid-cols-2 text-sm mb-4" : "w-[400px] grid gap-2 grid-cols-2 text-sm mb-4",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              className: "flex items-center",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "w-6 mr-1 text-center text-gray-500",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
                  icon: faIdCard/* faIdCard */.Uk
                })
              }), location.license_type === 'Medical' ? t('home:license_medical') : location.license_type]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              className: "flex items-center",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "w-6 mr-1 text-center text-gray-500",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
                  icon: faClock/* faClock */.SZ
                })
              }), openNow ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                  className: 'text-primary',
                  children: ["".concat(t('home:store_opentime'), " ").concat(closeTime), ";"]
                })
              }) : t('home:closed')]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              className: "flex items-center",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "w-6 mr-1 text-center text-gray-500",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
                  icon: faGrid2/* faGrid2 */.em
                })
              }), t("home:".concat(location.location_type))]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              className: "flex items-center",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "w-6 mr-1 text-center text-gray-500",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
                  icon: faCheckCircle/* faCheckCircle */.f8
                })
              }), t('home:store_license')]
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: "tel:".concat(location.phone_number),
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
              variant: 'outlined',
              className: 'mr-4',
              startIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
                icon: faPhoneVolume/* faPhoneVolume */.Eo
              }),
              children: location.phone_number
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: geo.located ? "https://maps.google.com/maps/dir/".concat(geo.latitude, ",").concat(geo.longitude, "/").concat(location.latitude, ",").concat(location.longitude) : "https://www.google.com/maps/place/".concat(location.latitude, ",").concat(location.longitude),
            target: '_blank',
            rel: 'noreferrer',
            className: 'font-bold text-primary-dark',
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
              variant: 'outlined',
              startIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
                icon: faMapLocationDot/* faMapLocationDot */.Yi
              }),
              children: t('home:store_direction')
            })
          })]
        }), " "]
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        children: t('home:loading')
      })
    })
  });
}
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./layouts/LocationLayout.js















var Tab = function Tab(_ref) {
  var href = _ref.href,
      active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      isMobile = _ref.isMobile;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
    href: href,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: isMobile ? (0,clsx_m/* default */.Z)('border-t-3 border-b-3 border-transparent py-3 px-3 -m-[1px]', {
          'border-b-primary font-bold': active
        }, className) : (0,clsx_m/* default */.Z)('border-t-3 border-b-3 border-transparent py-3 px-5 -m-[1px]', {
          'border-b-primary font-bold': active
        }, className),
        children: children
      })
    })
  });
};

function LocationLayout(_ref2) {
  var children = _ref2.children;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var location = (0,es/* useSelector */.v9)(function (state) {
    return state.location.location;
  });
  var router = (0,next_router.useRouter)();
  var slug = router.query.locationSlug;
  var id = router.query.id;

  var _useState = (0,react.useState)(false),
      isMobile = _useState[0],
      setIsMobile = _useState[1];

  (0,react.useEffect)(function () {
    console.log('location type : ', location.location_type);
    setIsMobile((0,helper.checkMobile)());
  }, [location]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LocationHeader, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper/* default */.Z, {
      className: isMobile ? 'py-1 w-full flex flex-row justify-center' : 'py-0 border-t border-b',
      children: location.location_type === 'CLINIC' ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.Z, {
        className: isMobile ? 'flex justify-center w-full overflow-scroll' : 'flex w-fit',
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tab, {
          className: isMobile ? 'flex w-full whitespace-nowrap items-center justify-center' : null,
          isMobile: isMobile,
          href: "/stores/".concat(slug, "/").concat(id),
          active: router.pathname === '/stores/[locationSlug]/[id]',
          children: t('home:about')
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tab, {
          className: isMobile ? 'flex w-full whitespace-nowrap items-center justify-center' : null,
          isMobile: isMobile,
          href: "/stores/".concat(slug, "/").concat(id, "/reviews"),
          active: router.pathname === '/stores/[locationSlug]/[id]/reviews',
          children: "Reviews"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tab, {
          className: isMobile ? 'flex w-full whitespace-nowrap items-center justify-center' : null,
          isMobile: isMobile,
          href: "/stores/".concat(slug, "/").concat(id, "/appointment"),
          active: router.pathname === '/stores/[locationSlug]/[id]/appointment',
          children: "Appointment"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tab, {
          className: isMobile ? 'flex w-full whitespace-nowrap items-center justify-center' : null,
          isMobile: isMobile,
          href: "/stores/".concat(slug, "/").concat(id, "/media"),
          active: router.pathname === '/stores/[locationSlug]/[id]/media',
          children: "Media"
        })]
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.Z, {
        className: isMobile ? 'grid grid-cols-2 justify-center w-full overflow-scroll' : 'flex w-full',
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tab, {
          className: isMobile ? 'flex w-full whitespace-nowrap items-center justify-center' : null,
          isMobile: isMobile,
          href: "/stores/".concat(slug, "/").concat(id),
          active: router.pathname === '/stores/[locationSlug]/[id]',
          children: t('home:store_product')
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tab, {
          className: isMobile ? 'flex w-full whitespace-nowrap items-center justify-center' : null,
          isMobile: isMobile,
          href: "/stores/".concat(slug, "/").concat(id, "/service"),
          active: router.pathname === '/stores/[locationSlug]/[id]/service',
          children: t('home:store_service')
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tab, {
          className: isMobile ? 'flex w-full whitespace-nowrap items-center justify-center' : null,
          isMobile: isMobile,
          href: "/stores/".concat(slug, "/").concat(id, "/about"),
          active: router.pathname === '/stores/[locationSlug]/[id]/about',
          children: t('home:store_about')
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tab, {
          className: isMobile ? 'flex w-full whitespace-nowrap items-center justify-center' : null,
          isMobile: isMobile,
          href: "/stores/".concat(slug, "/").concat(id, "/reviews"),
          active: router.pathname === '/stores/[locationSlug]/[id]/reviews',
          children: t('home:store_review')
        })]
      })
    }), children]
  });
}

/***/ }),

/***/ 95271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ calcOpenNow; }
/* harmony export */ });
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30120);

function calcOpenNow(hours, timezone) {
  var zonedNow = luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.now */ .ou.now().setZone(timezone);
  var tempHour = hours[zonedNow.weekdayLong.toLowerCase()];

  if (tempHour !== undefined) {
    var open = luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromFormat */ .ou.fromFormat(tempHour.open, 'hh:mma', {
      zone: timezone
    });
    var close = luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromFormat */ .ou.fromFormat(tempHour.close, 'hh:mma', {
      zone: timezone
    });
    return {
      isOpen: open < zonedNow && zonedNow < close,
      openTime: open.toFormat('hh:mm a').toUpperCase(),
      closeTime: close.toFormat('hh:mm a').toUpperCase()
    };
  } else {
    return {
      isOpen: false,
      openTime: '',
      closeTime: ''
    };
  }
}

/***/ })

}]);